/* ============================================================
   NUDRA — conversion behaviours (v3)
   Pack selector · Sticky ATC · Cart drawer upsell quick-add

   Hard rule learned the hard way: NO MutationObserver may watch
   a subtree this script writes into. Variant price sync is done
   via a Liquid-embedded variant→price JSON map + delegated
   change events instead. Every DOM write is value-compared
   first so repeated calls are no-ops.
   ============================================================ */
(function () {
  'use strict';

  var TICK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 auto;vertical-align:middle"><path d="m4.5 12.5 5 5 10-11"/></svg>';

  var moneyFormat = window.ndrMoneyFormat || '£{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var withComma = amount.replace('.', ',');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  /* Variant → price map embedded by the Liquid snippets. */
  function priceMapFor(scope) {
    var node = scope.querySelector('[data-ndr-variant-prices]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentVariantPrice(info) {
    var map = priceMapFor(info);
    if (!map) return null;
    var idInput = info.querySelector('input[name="id"], select[name="id"]');
    if (!idInput || !map.hasOwnProperty(idInput.value)) return null;
    return parseInt(map[idInput.value], 10);
  }

  /* ----------------------------------------------------------
     1. PACK SELECTOR (PDP bundle & save)
  ---------------------------------------------------------- */
  function initPackSelectors() {
    document.querySelectorAll('[data-ndr-packs]').forEach(function (wrap) {
      if (wrap.dataset.ndrInit) return;
      wrap.dataset.ndrInit = '1';

      var formId = wrap.dataset.formId;
      var qtyInput = wrap.querySelector('[data-ndr-pack-qty]');
      var options = Array.prototype.slice.call(wrap.querySelectorAll('.ndr-pack'));
      if (!options.length) return;

      function basePrice() {
        return parseInt(wrap.dataset.price, 10) || 0;
      }

      function renderPrices() {
        var price = basePrice();
        options.forEach(function (opt) {
          var qty = parseInt(opt.dataset.qty, 10) || 1;
          var save = parseFloat(opt.dataset.save) || 0;
          var full = price * qty;
          var total = Math.round(full * (1 - save / 100));
          setText(opt.querySelector('[data-ndr-pack-total]'), formatMoney(total));
          var fullEl = opt.querySelector('[data-ndr-pack-full]');
          if (fullEl) {
            setText(fullEl, save > 0 ? formatMoney(full) : '');
            if (fullEl.hidden !== (save <= 0)) fullEl.hidden = save <= 0;
          }
          var perEl = opt.querySelector('[data-ndr-pack-per]');
          if (perEl && qty > 1) setText(perEl, formatMoney(Math.round(total / qty)) + ' / pair');
        });
      }
      wrap.ndrRenderPrices = renderPrices;

      function select(opt) {
        if (!opt) return;
        options.forEach(function (o) {
          o.classList.toggle('is-selected', o === opt);
          var input = o.querySelector('input');
          if (input) input.checked = o === opt;
        });
        var qty = parseInt(opt.dataset.qty, 10) || 1;
        if (qtyInput && qtyInput.value !== String(qty)) {
          qtyInput.value = qty;
        }
        document.dispatchEvent(
          new CustomEvent('ndr:pack-change', {
            detail: { qty: qty, save: parseFloat(opt.dataset.save) || 0, formId: formId },
          })
        );
      }

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          select(opt);
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(opt);
          }
        });
      });

      // Pre-select: ?pack= URL param, else block default, else first.
      var preset = new URLSearchParams(window.location.search).get('pack');
      var initial = null;
      if (preset) {
        options.forEach(function (o) {
          if (!initial && o.dataset.qty === preset) initial = o;
        });
      }
      if (!initial) {
        options.forEach(function (o) {
          if (!initial && o.dataset.default === 'true') initial = o;
        });
      }
      select(initial || options[0]);
      renderPrices();
    });
  }

  /* ----------------------------------------------------------
     Variant change → price re-sync (NO MutationObserver).
     Dawn writes the selected variant id into input[name="id"]
     synchronously on selection. We re-read it after any change
     event inside product-info, look the price up in the
     embedded map, and only touch the DOM when it differs.
     A short delayed re-check covers Dawn's async section
     re-render without observing it.
  ---------------------------------------------------------- */
  function resyncPrice(info) {
    var price = currentVariantPrice(info);
    if (price === null) return;
    var changed = false;

    info.querySelectorAll('[data-ndr-packs]').forEach(function (wrap) {
      if (parseInt(wrap.dataset.price, 10) !== price) {
        wrap.dataset.price = String(price);
        changed = true;
      }
      if (changed && typeof wrap.ndrRenderPrices === 'function') wrap.ndrRenderPrices();
    });

    var bar = info.querySelector('[data-ndr-sticky-atc]');
    if (bar && parseInt(bar.dataset.price, 10) !== price) {
      bar.dataset.price = String(price);
      changed = true;
    }
    if (changed) {
      document.dispatchEvent(new CustomEvent('ndr:price-change', { detail: { price: price } }));
    }
  }

  document.addEventListener('change', function (e) {
    var info = e.target.closest('product-info');
    if (!info) return;
    requestAnimationFrame(function () {
      resyncPrice(info);
    });
    setTimeout(function () {
      resyncPrice(info);
    }, 350);
  });

  /* ----------------------------------------------------------
     2. STICKY ADD TO CART (mobile)
  ---------------------------------------------------------- */
  var stickyState = { qty: 1, save: 0 };

  function initStickyAtc() {
    var bar = document.querySelector('[data-ndr-sticky-atc]');
    if (!bar || bar.dataset.ndrInit) return;
    bar.dataset.ndrInit = '1';

    var sectionId = bar.dataset.section;
    var mainSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainSubmit) return;

    var stickyBtn = bar.querySelector('[data-ndr-sticky-submit]');
    var priceEl = bar.querySelector('[data-ndr-sticky-price]');

    function syncState() {
      var soldOut = mainSubmit.disabled;
      if (stickyBtn.disabled !== soldOut) stickyBtn.disabled = soldOut;
      setText(stickyBtn, soldOut ? stickyBtn.dataset.soldOutText : stickyBtn.dataset.addText);
      var base = parseInt(bar.dataset.price, 10) || 0;
      if (priceEl && base) {
        var total = Math.round(base * stickyState.qty * (1 - stickyState.save / 100));
        setText(
          priceEl,
          stickyState.qty > 1 ? formatMoney(total) + ' · ' + stickyState.qty + ' pairs' : formatMoney(total)
        );
      }
    }
    bar.ndrSyncState = syncState;

    // Attribute-filtered observer on the BUTTON NODE ONLY (no
    // subtree). syncState writes to the sticky bar, never to the
    // observed button, so this cannot self-trigger.
    new MutationObserver(syncState).observe(mainSubmit, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    stickyBtn.addEventListener('click', function () {
      if (!mainSubmit.disabled) mainSubmit.click();
    });

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    ).observe(mainSubmit);

    syncState();
  }

  // Module-level listeners bound ONCE (initStickyAtc can run
  // repeatedly via shopify:section:load without stacking these).
  document.addEventListener('ndr:pack-change', function (e) {
    stickyState.qty = e.detail.qty;
    stickyState.save = e.detail.save;
    var bar = document.querySelector('[data-ndr-sticky-atc]');
    if (bar && typeof bar.ndrSyncState === 'function') bar.ndrSyncState();
  });
  document.addEventListener('ndr:price-change', function () {
    var bar = document.querySelector('[data-ndr-sticky-atc]');
    if (bar && typeof bar.ndrSyncState === 'function') bar.ndrSyncState();
  });

  /* ----------------------------------------------------------
     3. CART DRAWER UPSELL — quick add (delegated, observer-free)
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ndr-upsell-add]');
    if (!btn || btn.disabled) return;

    var item = btn.closest('[data-ndr-upsell-item]');
    var select = item ? item.querySelector('[data-ndr-upsell-variant]') : null;
    var variantId = select ? select.value : btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = btn.dataset.addingText || '…';

    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Could not add item');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('ndr:upsell-added', { detail: { variantId: variantId } }));
      })
      .catch(function (err) {
        console.error('[Nudra upsell]', err);
        btn.textContent = original;
        btn.disabled = false;
      });
  });


  /* ----------------------------------------------------------
     SHIPPING BAR — keep every [data-ndr-shipbar] live.
     Recomputes fill width + message from the real cart total
     after any add/change. money formatting via window.ndrMoneyFormat.
  ---------------------------------------------------------- */
  function renderShipbar(bar, totalCents) {
    var t1 = parseInt(bar.dataset.threshold, 10) || 0;
    var t2 = parseInt(bar.dataset.threshold2, 10) || 0;
    var two = bar.dataset.two === '1' && t2 > t1;
    if (!t1) return;
    var goal = two ? t2 : t1;
    var pct = totalCents > 0 ? Math.min(100, (totalCents * 100) / goal) : 0;

    var fill = bar.querySelector('[data-ndr-shipbar-fill]');
    var msg = bar.querySelector('[data-ndr-shipbar-msg]');
    var stop1 = bar.querySelector('[data-ndr-shipbar-stop1]');
    var stop2 = bar.querySelector('[data-ndr-shipbar-stop2]');
    var label2 = bar.dataset.label2 || 'a free pair';

    if (fill) {
      fill.style.width = pct.toFixed(1) + '%';
      fill.style.display = 'block'; // Dawn base.css div:empty{display:none} hides the empty fill div
      fill.classList.toggle('is-complete', totalCents >= goal);
    }
    if (stop1) stop1.classList.toggle('is-hit', totalCents >= t1);
    if (stop2) stop2.classList.toggle('is-hit', totalCents >= goal);

    if (!msg) return;
    var lc = label2.toLowerCase();
    if (two) {
      if (totalCents >= t2) {
        msg.innerHTML = TICK + " You've unlocked " + escapeHtml(lc) + ' + free delivery';
      } else if (totalCents >= t1) {
        msg.innerHTML = 'Add <strong>' + formatMoney(t2 - totalCents) + '</strong> more to get ' + escapeHtml(lc);
      } else if (totalCents > 0) {
        msg.innerHTML = 'Add <strong>' + formatMoney(t1 - totalCents) + '</strong> more for free delivery';
      } else {
        msg.innerHTML = 'Spend <strong>' + formatMoney(t1) + '</strong> for free delivery';
      }
    } else {
      if (totalCents >= t1) {
        msg.innerHTML = TICK + " You've unlocked free UK delivery";
      } else if (totalCents > 0) {
        msg.innerHTML = 'Add <strong>' + formatMoney(t1 - totalCents) + '</strong> more for free UK delivery';
      } else {
        msg.innerHTML = 'Free UK delivery on orders over <strong>' + formatMoney(t1) + '</strong>';
      }
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function updateAllShipbars(totalCents) {
    var bars = document.querySelectorAll('[data-ndr-shipbar]');
    bars.forEach(function (bar) { renderShipbar(bar, totalCents); });
  }

  function refreshShipbarsFromCart() {
    if (!document.querySelector('[data-ndr-shipbar]')) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateAllShipbars(cart.total_price); })
      .catch(function () {});
  }


  // Patch fetch so ANY cart mutation (Dawn's own add/change, our upsell)
  // triggers a shipbar refresh once the request settles.
  (function () {
    if (!window.fetch || window.__ndrFetchPatched) return;
    window.__ndrFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = (args[0] && args[0].url) || args[0] || '';
      return orig.apply(this, args).then(function (res) {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          setTimeout(refreshShipbarsFromCart, 60);
        }
        return res;
      });
    };
  })();

  document.addEventListener('ndr:upsell-added', refreshShipbarsFromCart);
  document.addEventListener('shopify:section:load', function () { refreshShipbarsFromCart(); watchCartContainers(); });


  /* ----------------------------------------------------------
     Cart-page / drawer shipbar trigger.
     Dawn re-renders #main-cart-items, #main-cart-footer and the
     drawer on every qty change. We observe those containers (NOT
     the shipbar, so no self-trigger) and refresh the bar from
     /cart.js when they mutate. Debounced.
  ---------------------------------------------------------- */
  var _shipbarTimer = null;
  function scheduleShipbarRefresh() {
    if (_shipbarTimer) clearTimeout(_shipbarTimer);
    _shipbarTimer = setTimeout(refreshShipbarsFromCart, 120);
  }

  function watchCartContainers() {
    if (!document.querySelector('[data-ndr-shipbar]')) return;
    var watch = [];
    ['main-cart-items', 'main-cart-footer', 'CartDrawer-CartItems'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) watch.push(el);
    });
    // Dawn's cart custom elements (tag names) as a fallback
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
      if (watch.indexOf(el) === -1) watch.push(el);
    });
    watch.forEach(function (el) {
      if (el.__ndrShipWatched) return;
      el.__ndrShipWatched = true;
      new MutationObserver(scheduleShipbarRefresh).observe(el, { childList: true, subtree: true });
    });
  }


  /* ----------------------------------------------------------
     Hook Dawn's cart renderers directly. After Dawn rebuilds the
     drawer or cart contents, recompute the shipbar from the fresh
     cart. This is independent of fetch-patching or observers, so
     it works regardless of how Dawn captured its own references.
  ---------------------------------------------------------- */
  function hookDawnCart() {
    try {
      if (window.CartDrawer && window.CartDrawer.prototype && !window.CartDrawer.prototype.__ndrHooked) {
        window.CartDrawer.prototype.__ndrHooked = true;
        var rc = window.CartDrawer.prototype.renderContents;
        window.CartDrawer.prototype.renderContents = function (state) {
          var r = rc.apply(this, arguments);
          if (state && typeof state.total_price === 'number') updateAllShipbars(state.total_price);
          else scheduleShipbarRefresh();
          return r;
        };
      }
    } catch (e) {}
    try {
      if (window.CartItems && window.CartItems.prototype && !window.CartItems.prototype.__ndrHooked) {
        window.CartItems.prototype.__ndrHooked = true;
        var uq = window.CartItems.prototype.updateQuantity;
        if (uq) {
          window.CartItems.prototype.updateQuantity = function () {
            var r = uq.apply(this, arguments);
            scheduleShipbarRefresh();
            return r;
          };
        }
      }
    } catch (e) {}
  }

  /* ----------------------------------------------------------
     EMAIL SIGNUP POPUP
     Shows once per visitor after a delay; dismissal remembered.
     Auto-opens (with success state) when the form posts back.
  ---------------------------------------------------------- */
  function initPopup() {
    var popup = document.querySelector('[data-ndr-popup]');
    if (!popup || popup.dataset.ndrInit) return;
    popup.dataset.ndrInit = '1';

    var KEY = 'ndr_popup_seen';

    function open() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    }
    function dismiss() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    }

    popup.querySelectorAll('[data-ndr-popup-close]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) dismiss();
    });

    // Returned from a successful signup: show success + never show again.
    if (popup.getAttribute('data-force-open') === '1') {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      open();
      return;
    }

    var seen = null;
    try { seen = localStorage.getItem(KEY); } catch (e) {}
    if (seen) return;

    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 6) * 1000;
    setTimeout(open, delay);
  }

  /* ---------------------------------------------------------- */
  function init() {
    initPackSelectors();
    initStickyAtc();
    initPopup();
    if (document.querySelector('[data-ndr-sticky-atc]')) {
      document.body.classList.add('ndr-has-sticky');
    }
    refreshShipbarsFromCart();
    watchCartContainers();
    hookDawnCart();
    setTimeout(hookDawnCart, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
